import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import {
  COMING_SOON_FEATURE,
  COMING_SOON_FEATURES,
  ComingSoonFeatureKey,
} from 'components/ComingSoonFeatures/constants';
import Loader from 'components/lib/Loader';
import {
  canAccessAICompetitiveIntelligence,
  canAccessAISpeedToLead,
  canAccessComingSoonFeatures,
  hasAISpeedToLeadFlag,
} from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import { AICI_ANALYSIS_SCOPE } from './constants';
import useAICIAnalysisAvailability from './useAICIAnalysisAvailability';

const AICIIndexRedirect = () => {
  const [searchParams] = useSearchParams();
  const { currentUser } = useAppSelector((state) => state.auth);
  const nextSearchParams = new URLSearchParams(searchParams);
  const communityIdParam = nextSearchParams.get('communityId');
  const communityId = communityIdParam ? Number(communityIdParam) : undefined;
  const scope = communityId ? AICI_ANALYSIS_SCOPE.COMMUNITY : AICI_ANALYSIS_SCOPE.COMPANY;
  const { hasOverallAnalysis, hasSpeedToLeadAnalysis, isLoading } = useAICIAnalysisAvailability({
    communityId,
    scope,
  });
  const releasedComingSoonFeatures: ComingSoonFeatureKey[] = hasAISpeedToLeadFlag(currentUser)
    ? [COMING_SOON_FEATURE.SPEED_TO_LEAD]
    : [];
  const comingSoonFeatures = canAccessComingSoonFeatures(currentUser)
    ? COMING_SOON_FEATURES.filter((feature) => !releasedComingSoonFeatures.includes(feature.key))
    : [];

  nextSearchParams.delete('analysis');

  if (isLoading) {
    return <Loader active />;
  }

  let route: string;
  if (canAccessAICompetitiveIntelligence(currentUser) && (hasOverallAnalysis || !hasSpeedToLeadAnalysis)) {
    route = 'overall-market-position';
  } else if (canAccessAISpeedToLead(currentUser)) {
    route = 'speed-to-lead';
  } else if (comingSoonFeatures.length) {
    route = `coming-soon/${comingSoonFeatures[0].key}`;
  } else {
    route = 'overall-market-position';
  }
  const search = nextSearchParams.toString();

  return <Navigate to={`${route}${search ? `?${search}` : ''}`} replace />;
};

export default AICIIndexRedirect;
